var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"square-button-container",class:[_vm.pressedClass, _vm.disabledClass],on:{"mousedown":_vm.onClick}},[_c('Icon',{staticClass:"fitted",attrs:{"value":_vm.icon,"color":_vm.color,"height":_vm.size,"width":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }